import React from 'react';

export default function LoadingModal({ onClose, message }) {
  return (
    <>
      <div className="modal-header">
        <h2 className="modal-title">{message || 'Loading...'}</h2>
      </div>
      <div className="modal-body saveBuildModalBody">
        <div style={{ textAlign: 'center', padding: '20px' }}>
          <div className="spinner"></div>
        </div>
      </div>
    </>
  );
}